import {ItemImageDto} from '../../../items/items.service';

/** Keeps the representative item's main photo first, without mixing group members. */
export function itemGalleryUrls(images: readonly ItemImageDto[] | undefined): string[] {
  const ordered = [...(images ?? [])].sort((a, b) => Number(b.isMain) - Number(a.isMain));
  const urls = ordered.map(image => image.originalUrl).filter(url => !!url?.trim());
  return [...new Set(urls)];
}
